import { memo, useEffect, useRef } from 'react'

import { useQuery } from '@tanstack/react-query'

import type { EditorInstance } from '@shared/components/Editor'
import { Editor } from '@shared/components/Editor'
import { LoadingIndicator, NotFound } from '@shared/layouts'
import { eventRawRoute } from 'pages/NWPlatform/Workspaces/Workspace/Events/Event'
import { eventQueryKeys } from 'services/queryKeys'
import { RefetchIntervals } from 'types/query'

const JSONRaw = () => {
  const { eventId } = eventRawRoute.useParams()

  const editorInstanceRef = useRef<EditorInstance>(undefined)

  const eventQuery = useQuery({
    ...eventQueryKeys.detail({ eventId }),
    refetchInterval: RefetchIntervals.FAST,
  })

  useEffect(() => {
    if (editorInstanceRef.current && eventQuery.isSuccess) {
      editorInstanceRef.current.getModel()?.setValue(window.JSON.stringify(eventQuery.data.status, null, 4))
    }
  }, [eventQuery.data?.status, eventQuery.isSuccess])

  if (eventQuery.isLoading) {
    return <LoadingIndicator />
  }

  if (eventQuery.isSuccess) {
    return (
      <Editor
        value={eventQuery.data.status}
        readOnly
        readOnlyLabel="Read-only (Auto Refresh)"
        getEditorInstance={(editorInstance: EditorInstance) => void (editorInstanceRef.current = editorInstance)}
      />
    )
  }

  return <NotFound />
}

export const JSON = memo(JSONRaw)
